import React, { PropsWithChildren } from 'react';
import { Container } from '@fiverr-private/layout_components';

const GIG_PAGE_UPMARKET_BANNER_CLASS = 'gig-page-upmarket-banner';

export const BannerWrapper: React.FC<PropsWithChildren<unknown>> = ({ children }) => (
  <Container className={GIG_PAGE_UPMARKET_BANNER_CLASS}>{children}</Container>
);
